import { createReducer, on } from '@ngrx/store';
import * as SquareLocationProductionActions from './square-location-production.actions';
import { SquareLocationProduction } from './square-location-production.models';

// ----------------------------------------------------------------------
// @ States
// ----------------------------------------------------------------------

export interface SquareLocationProductionsState {
    squareLocationProductions: SquareLocationProduction[];
    squareLocationProduction: SquareLocationProduction | null;
    isLoading: boolean;
    error: string | null;
}

// ----------------------------------------------------------------------
// @ Initial States
// ----------------------------------------------------------------------

export const initialSquareLocationProductionsState: SquareLocationProductionsState =
    {
        squareLocationProductions: [],
        squareLocationProduction: null,
        isLoading: false,
        error: null,
    };

// ----------------------------------------------------------------------
// @ Reducers
// ----------------------------------------------------------------------

export const squareLocationProductionsReducer = createReducer(
    initialSquareLocationProductionsState,

    // On Load All
    on(SquareLocationProductionActions.loadSquareLocationProductions, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(
        SquareLocationProductionActions.loadSquareLocationProductionsSuccess,
        (state, { squareLocationProductions }) => ({
            ...state,
            isLoading: false,
            squareLocationProductions,
        })
    ),
    on(
        SquareLocationProductionActions.loadSquareLocationProductionsFailure,
        (state, { error }) => ({
            ...state,
            isLoading: false,
            error,
        })
    ),

    // On Load Single
    on(SquareLocationProductionActions.loadSquareLocationProduction, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(
        SquareLocationProductionActions.loadSquareLocationProductionSuccess,
        (state, { squareLocationProduction }) => ({
            ...state,
            isLoading: false,
            squareLocationProduction,
        })
    ),
    on(
        SquareLocationProductionActions.loadSquareLocationProductionFailure,
        (state, { error }) => ({
            ...state,
            isLoading: false,
            error,
        })
    ),

    // On Create
    on(SquareLocationProductionActions.createSquareLocationProduction, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(
        SquareLocationProductionActions.createSquareLocationProductionSuccess,
        (state, { squareLocationProduction }) => ({
            ...state,
            isLoading: false,
            squareLocationProductions: [
                ...(state.squareLocationProductions || []),
                squareLocationProduction,
            ],
        })
    ),
    on(
        SquareLocationProductionActions.createSquareLocationProductionFailure,
        (state, { error }) => ({
            ...state,
            isLoading: false,
            error,
        })
    ),

    // On Update
    on(SquareLocationProductionActions.updateSquareLocationProduction, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(
        SquareLocationProductionActions.updateSquareLocationProductionSuccess,
        (state, { squareLocationProduction }) => ({
            ...state,
            isLoading: false,
            squareLocationProductions: state.squareLocationProductions.map((s) =>
                s.id === squareLocationProduction.id ? squareLocationProduction : s
            ),
        })
    ),
    on(
        SquareLocationProductionActions.updateSquareLocationProductionFailure,
        (state, { error }) => ({
            ...state,
            isLoading: false,
            error,
        })
    ),

    // On Delete
    on(SquareLocationProductionActions.deleteSquareLocationProduction, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(
        SquareLocationProductionActions.deleteSquareLocationProductionSuccess,
        (state, { id }) => ({
            ...state,
            isLoading: false,
            squareLocationProductions: state.squareLocationProductions.filter(
                (s) => s.id !== id
            ),
        })
    ),
    on(
        SquareLocationProductionActions.deleteSquareLocationProductionFailure,
        (state, { error }) => ({
            ...state,
            isLoading: false,
            error,
        })
    )
);
